/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive } from '@angular/core';
import { padStart } from 'lodash';
import {
  GANTT_CHART_ACCESSOR,
  GANTT_CHART_CONTROLLER,
  GanttChartAccessor,
  GanttChartController,
  GanttChartTimelineDirective,
  GanttChartView,
} from './gantt-chart-timeline.directive';

const TEMPLATE_TASK_START_DATE = new Date(0);
const MS_IN_DAY = 24 * 60 * 60 * 1000;
const GANTT_BASE_TEMPLATE_COLUMN_WIDTH = 37;

function dateToDaySince1970(date: Date): string {
  const daysSince1970 = Math.floor((date.getTime() - TEMPLATE_TASK_START_DATE.getTime()) / MS_IN_DAY);
  return daysSince1970 >= 0 ? padStart(String(daysSince1970 + 1), 2, '0') : '';
}

@Directive({
  standalone: false,
  selector: '[ghGanttChartTimelineTemplate]',
  providers: [
    { provide: GANTT_CHART_ACCESSOR, useExisting: GanttChartTimelineTemplateDirective, multi: true },
    { provide: GANTT_CHART_CONTROLLER, useExisting: GanttChartTimelineTemplateDirective },
  ],
})
export class GanttChartTimelineTemplateDirective implements GanttChartAccessor, GanttChartController {
  minScale = 0.9;
  maxScale = 2;

  private gantt: GanttStatic;

  constructor(private timeline: GanttChartTimelineDirective) {
  }

  onGanttConfig(gantt: GanttStatic): void {
    this.gantt = gantt;
    gantt.config.static_background = false;
    gantt.config.select_task = true;
    gantt.config.show_task_cells = true;
    gantt.config.date_scale = <any>void 0;
    gantt.config.scale_unit = GanttChartView.DAY;
    gantt.config.scale_height = 60;
    gantt.config.drag_progress = false;
    gantt.config.show_progress = false;
    gantt.config.min_column_width = GANTT_BASE_TEMPLATE_COLUMN_WIDTH;

    gantt.templates.date_scale = dateToDaySince1970;
    this.timeline.setupTooltipTemplate([
      { field: 'duration', title: 'lbl_duration' },
      { field: 'description', title: 'lbl_description'},
    ]);
  }

  onGanttReady(gantt: GanttStatic): void {
    this.timeline.setAllWorkingDays();
  }

  onGanttDestroy(gantt: GanttStatic): void {
    // nothing to do
  }

  setScale(scale: number): void {
    this.gantt.config.min_column_width = GANTT_BASE_TEMPLATE_COLUMN_WIDTH * scale;
    this.gantt.render();
  }

  setView(view: GanttChartView): void {
    // nothing to do
  }
}
